import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { bookmarkedTutorialsReselector as stateSelector } from 'reduxModules/tutorials/selectors'
import { bookmarkedTutorialsDispatchers as dispatchSelector } from 'reduxModules/tutorials/dispatchers'
import BookmarkedTutorial from './BookmarkedTutorial'

export class BookmarkList extends Component {
  componentDidMount() {
    this.props.fetchBookmarkedTutorials()
  }

  render() {
    const { bookmarkedTutorials, removeBookmark, loadBookmark } = this.props
    return (
      <div id="BookmarkList" className="account-section">
        <h3 className="account-section__title">Bookmarks</h3>
        {_.size(bookmarkedTutorials) > 0 ? (
          bookmarkedTutorials.map((tutorial) => (
            <BookmarkedTutorial
              key={tutorial.id}
              {...tutorial}
              removeBookmark={removeBookmark}
              loadBookmark={loadBookmark}
            />
          ))
        ) : (
          <div className="no-results">
            <span>You don&apos;t have any bookmarks yet.</span>
          </div>
        )}
      </div>
    )
  }
}

BookmarkList.propTypes = {
  fetchBookmarkedTutorials: PropTypes.func.isRequired,
  bookmarkedTutorials: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })),
  removeBookmark: PropTypes.func,
  loadBookmark: PropTypes.func
}

BookmarkList.defaultProps = {
  bookmarkedTutorials: [],
  removeBookmark: () => {},
  loadBookmark: () => {}
}

export default connect(
  stateSelector,
  dispatchSelector
)(BookmarkList)
